import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import DashboardContext, { reducer, buildDefaultState } from './dashboard-components/context';
import Main from './dashboard-components/main';
import { recordStatisticsEvent } from '../../services/statistics-service';

export default function Dashboard(props) {
  const common = commonProps();
  const [state, dispatch] = React.useReducer(
    reducer,
    buildDefaultState(_.get(props.partnership, 'contributors', [])),
  );

  React.useEffect(() => {
    recordStatisticsEvent({
      event: 'performance_report_page_view',
      statisticable: 'profile',
      id: _.get(window, 'Livewire.currentUser.profile.id'),
    });
  }, []);

  if (!props.partnership) {
    return null;
  }

  return (
    <ThemeProvider theme={common}>
      <DashboardContext.Provider value={{ state, dispatch }}>
        <Main {...props} />
      </DashboardContext.Provider>
    </ThemeProvider>
  );
}

Dashboard.propTypes = {
  partnership: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    cachedAnalyticsDataUrls: PropTypes.shape({
      performanceDataFromDatabaseUrl: PropTypes.string,
    }),
    contributors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
      createdAt: PropTypes.string,
    })).isRequired,
  }),
  mobileImageUrl: PropTypes.string.isRequired,
  newDashboard: PropTypes.bool.isRequired,
};

Dashboard.defaultProps = {
  partnership: null,
};
